import React, { Component } from "react";
import ReactQuill, { Quill } from "react-quill"; // ES6
import ImageResize from "quill-image-resize-module-react";
import VideoResize from "quill-video-resize-module";
import { resizeBase64 } from "../../components/staleUploadImgFunctions"

require("react-quill/dist/quill.snow.css"); // CommonJS

Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/videoResize", VideoResize);



const resizeImage = (image) => new Promise(resolve => {

  resizeBase64(image, 1024, 1024, function (resizedDataUrl) {
    return resolve( resizedDataUrl )
  })
})

const convertBase64 = (file) => new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file)
    fileReader.onload = () => {
      resolve(fileReader.result);
    }
    fileReader.onerror = (error) => {
      reject(error);
    }
  })


const toolbarOptions = {
  container: [
  [{ header: [1, 2, false] }],
  ["bold", "italic", "underline", "strike", "blockquote"],
  [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
  ["link", "image", "video"],
  ["clean"],
  ],
  handlers: {image: async function() { 
    
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();
    input.onchange = async function() {
      const file = input.files[0];
      const base64File = await convertBase64(file);
      const base64FileScale = await resizeImage(base64File);

      // const id = await uploadFile(file); // I'm using react, so whatever upload function
      const range = this.quill.getSelection();
      // const link = `${ROOT_URL}/file/${id}`;


      // this part the image is inserted
      // by 'image' option below, you just have to put src(link) of img here. 
      this.quill.insertEmbed(range.index, 'image', base64FileScale); 
    }.bind(this); // react thing

  } }
}

class MyComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
    };
  }

  modules = {
    toolbar: toolbarOptions,
    imageResize: {
      modules: ["Resize", "DisplaySize", "Toolbar"],
      // See optional "config" below
    },
    videoResize: {
      modules: ["Resize", "DisplaySize", "Toolbar"],
      // See optional "config" below
    },
  };

  formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];



  render() {
    const { onChange, defaultValue } = this.props;
    return (
      <div className="text-editor">
        <ReactQuill
          style={{ minHeight: 100 }}
          theme="snow"
          modules={this.modules}
          formats={this.formats}
          defaultValue={defaultValue}
          onChange={(range, source, quill) => {
            onChange(range);
          }}
        />
      </div>
    );
  }
}

export default MyComponent;



// WEBPACK FOOTER //
// ./src/screens/ManageArticle/ArtickeEditor.js